import { Color, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfPageCounterStyles = StyleSheet.create({
  pageCounterText: {
    position: 'absolute',
    fontSize: 10,
    bottom: Spacing.S16,
    right: Spacing.S32,
    textAlign: 'center',
    color: Color.Grey500,
  },
})
